.liquidate {
  padding: 2rem 3rem;
  background-color: var(--deposit-withdraw-bg-color);
  border-radius: 1rem;
  margin: 1rem 1rem;
}

.liquidationCard {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.inputWrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.inputSubmitBtn {
  display: flex;
  gap: 2rem;
}

.confirmLiquidationButton {
  display: flex;
}
